<div class="row accepted-credit-cards" *ngIf="acceptedCreditCards.length > 0">
  <div class="col-lg-12">
    <span [attr.class]="cssClass" *ngFor="let x of acceptedCreditCards">
      <img src="{{x.imagePath}}" (click)="cardClick(x)" />
    </span>
  </div>
</div>
